import { render, staticRenderFns } from "./PagePad.vue?vue&type=template&id=2c99a2c7&scoped=true&"
import script from "./PagePad.vue?vue&type=script&lang=js&"
export * from "./PagePad.vue?vue&type=script&lang=js&"
import style0 from "./PagePad.vue?vue&type=style&index=0&id=2c99a2c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c99a2c7",
  null
  
)

export default component.exports